<template>
  <common-page title="注册新账号">
    <el-steps :active="stepActive" simple finish-status="success">
      <el-step title="基础信息"/>
      <el-step title="详细信息"/>
      <el-step title="完成注册"/>
    </el-steps>
    <el-form v-if="stepActive===0" ref="stepForm_0" :model="form" :rules="rules" label-width="120px">
      <el-form-item prop="regPhone" label="手机号">
        <el-input v-model="form.regPhone" prefix-icon="el-icon-phone" clearable
                  :placeholder="$t('login.mobilePlaceholder')">
          <template #prepend>+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="verifyCode" label="验证码">
        <div class="login-msg-yzm">
          <el-input
            v-model="form.verifyCode"
            auto-complete="off"
            placeholder="验证码"
            prefix-icon="el-icon-lollipop"
          >
          </el-input>
          <img :src="codeUrl" @click="getCode"/>
        </div>
      </el-form-item>
      <el-form-item label="短信验证码" prop="yzm" style="margin-bottom: 35px;">
        <div class="login-msg-yzm">
          <el-input v-model="form.yzm" prefix-icon="el-icon-unlock" clearable
                    :placeholder="$t('login.smsPlaceholder')"></el-input>
          <el-button @click="getYzm" :disabled="disabled">{{ this.$t('login.smsGet') }}<span
            v-if="disabled"> ({{ time }})</span></el-button>
        </div>
      </el-form-item>
      <el-form-item label="登录密码" prop="password">
        <el-input v-model="form.password" type="password" show-password placeholder="请输入登录密码"></el-input>
        <PasswordStrength :modelValue="form.password"></PasswordStrength>
        <div class="el-form-item-msg">请输入包含英文、数字的8位以上密码</div>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" show-password placeholder="请再一次输入登录密码"></el-input>
      </el-form-item>
      <el-form-item label="" prop="agree">
        <el-checkbox v-model="form.agree" label="">已阅读并同意</el-checkbox>
        <span class="link" @click="showAgree=true">《平台服务协议》</span>
      </el-form-item>
    </el-form>
    <el-form v-if="stepActive===1" ref="stepForm_1" :model="form" :rules="rules_1" label-width="120px">
      <el-form-item label="商户名称" prop="name">
        <el-input class="max-w460" v-model="form.name" placeholder="请输入商户名称"></el-input>
      </el-form-item>
      <el-form-item label="登录名" prop="userName">
        <el-input class="max-w460" v-model="form.userName" placeholder="请输入登录名"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="linkName">
        <el-input class="max-w460" v-model="form.linkName" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="linkPhone">
        <el-input class="max-w460" v-model="form.linkPhone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入联系地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商家介绍" prop="description">
        <el-input type="textarea" v-model="form.description" class="max-w460"></el-input>
      </el-form-item>
    </el-form>
    <div v-if="stepActive===2">
      <el-result icon="success" title="注册成功" sub-title="审核完成后，您可以使用登录账号以及手机号登录系统">
        <template #extra>
          <el-button type="primary" @click="goLogin">前去登录</el-button>
        </template>
      </el-result>
    </div>
    <el-form style="text-align: center;">
      <el-button v-if="stepActive>0 && stepActive<2" @click="pre">上一步</el-button>
      <el-button v-if="stepActive<1" type="primary" @click="next">下一步</el-button>
      <el-button v-if="stepActive===1" type="primary" @click="save">提交</el-button>
    </el-form>
    <el-dialog v-model="showAgree" title="平台服务协议" width="800px" destroy-on-close>
      平台服务协议
      <template #footer>
        <el-button @click="showAgree=false">取消</el-button>
        <el-button type="primary" @click="showAgree=false;form.agree=true;">我已阅读并同意</el-button>
      </template>
    </el-dialog>
  </common-page>
</template>

<script>
import PasswordStrength from '@/components/PasswordStrength';
import commonPage from './components/commonPage'
import ImageUpload from '@/components/ImageUpload';
import UserApi from '@/api/user.js';
import defaultSettings from '@/config/env'

export default {
  components: {
    /*上传组件*/
    ImageUpload,
    commonPage,
    PasswordStrength
  },
  data() {
    return {
      codeUrl: "",
      stepActive: 0,
      disabled: false,
      yzmChecked: false,
      time: 0,
      showAgree: false,
      form: {
        password: "",
        confirmPassword: "",
        agree: false,
        regPhone: "",
        userName: "",
        name: "",
        verifyCode: "",
        userType: "1",
        description: "",
        linkName: "",
        linkPhone: "",
        address: "",
      },
      rules: {
        regPhone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        userName: [
          {required: true, message: '请输入登录名', validator: this.checkExistName, trigger: ['blur', 'change']}
        ],
        password: [
          {required: true, message: '请输入密码'}
        ],
        verifyCode: [
          {required: true, message: '请输入验证码'}
        ],
        yzm: [
          {required: true, message: '请输入短信验证码'}
        ],
        confirmPassword: [
          {required: true, message: '请再次输入密码'},
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }
          }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请阅读并同意协议'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      rules_1: {}
    }
  },
  mounted() {
    this.getCode();
  },
  methods: {
    getCode() {
      let self = this;
      UserApi.getCodeImg({width: 130, height: 40})
        .then(res => {
          self.codeUrl = res.data.base64;
          self.form.verifyKey = res.data.key;
        });
    },
    pre() {
      this.stepActive -= 1
    },
    next() {
      const formName = `stepForm_${this.stepActive}`
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.stepActive === 0) {
            if (this.yzmChecked === true) {
              this.form.userName = this.form.regPhone
              this.stepActive += 1
            } else {
              this.$message.error(this.$t('login.checkSmsFirst'))
              return false
            }
          }
        } else {
          return false
        }
      })
    },
    save() {
      let self = this;
      const formName = `stepForm_${this.stepActive}`
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let Params = {
            ...self.form
          };
          Params.verifyCode = self.form.yzm;
          Params.verifyKey = self.form.regPhone;
          Params.appId = defaultSettings.APP_ID;

          UserApi.applyUser(Params)
            .then(res => {
              self.stepActive += 1
            })
            .catch(error => {
            });
        } else {
          return false
        }
      })
    },
    goLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    /**
     * 校验多个字段
     */
    async validateFields() {
      let self = this;
      // 需要校验的字段
      let fieldsToValidate = ['regPhone', 'verifyCode'];
      // 将回调转换为Promise
      return await Promise.all(
        fieldsToValidate.map((field) => {
          return new Promise((resolve, reject) => {
            self.$refs.stepForm_0.validateField(field, (errorMessage) => {
              resolve(errorMessage);
            });
          });
        })
      ).then((errorMessages) => {
        // 判断errorMessages 里是否全是空串
        return errorMessages.every((errorMessage) => {
          return errorMessage === '';
        });
      });
    },
    async getYzm() {
      let self = this;
      const validate = await self.validateFields();
      if (!validate) {
        return false
      }
      const validatePhone = await self.checkExistName();
      if (!validatePhone) {
        return false
      }
      let Params = {
        telephone: self.form.regPhone,
        verifyCode: self.form.verifyCode,
        verifyKey: self.form.verifyKey,
      };
      UserApi.getCodeSms(Params)
        .then(res => {
          self.$message.success(this.$t('login.smsSent'))
          self.disabled = true
          self.yzmChecked = true
        })
        .catch(error => {
          self.disabled = true
        });

      self.time = 60
      let t = setInterval(() => {
        self.time -= 1
        if (self.time < 1) {
          clearInterval(t)
          self.disabled = false
          self.time = 0
        }
      }, 1000)
    },
    async checkExistName() {
      let self = this;
      let Params = {
        userName: self.form.regPhone,
      };
      return await new Promise((resolve, reject) => {
        UserApi.checkExistName(Params)
          .then(res => {
            if (res.data === true) {
              self.$message.error(this.$t('login.regPhoneExist'))
              reject()
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            reject()
          });
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.login-msg-yzm {
  display: flex;
  width: 100%;

  .el-button {
    margin-left: 10px;
    --el-button-size: 42px;
  }

  img {
    width: 100px;
    height: 35px;
    cursor: pointer;
    vertical-align: middle;
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/login/register.vue